module.exports = __webpack_public_path__ + "static/img/pen.731bbec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/pen.png
// module id = 5zL9
// module chunks = 1